/* Wording for a length of time a player reads: a round's length in the lobby, and what is left
of the round on the clock. Pure, so the lobby's picker, the top bar's countdown and the "host is
gone" notice cannot spell the same number three ways.

A round used to be seconds and nothing else ("60s"), and with rounds of an hour, a day and a
week (2026-09-22) a lobby offering "604800s" is a lobby nobody reads. */

const UNITS = [
  ["weeks", 7 * 24 * 60 * 60],
  ["days", 24 * 60 * 60],
  ["hours", 60 * 60],
  ["minutes", 60],
]

/* A round's length, in the largest unit that divides it exactly: "30s", "2 min", "1 hour",
"1 day", "1 week". */
export const roundLengthLabel = (seconds, t) => {
  const total = Number(seconds) || 0
  for (const [unit, size] of UNITS) {
    if (total >= size && total % size === 0) return t(`duration.${unit}`, { count: total / size })
  }
  return t("duration.seconds", { count: total })
}

/* What is left of a round, in its two largest non-zero units so the number keeps moving:
"3d 4h", "4h 12m", "12m 05s", "45s". Never negative; an overdue round reads 0. */
export const timeLeftLabel = (seconds) => {
  const total = Math.max(0, Math.floor(Number(seconds) || 0))
  const days = Math.floor(total / 86400)
  const hours = Math.floor((total % 86400) / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const secs = total % 60
  const pad = (n) => String(n).padStart(2, "0")
  if (days > 0) return `${days}d ${hours}h`
  if (hours > 0) return `${hours}h ${pad(minutes)}m`
  if (minutes > 0) return `${minutes}m ${pad(secs)}s`
  return `${secs}s`
}
